import type { VehicleType } from "@daytrip/legacy-enums";
import { Exclude, Expose, Type } from "class-transformer";
import { ArrayNotEmpty, IsArray, IsDate, IsDefined, IsUUID } from "class-validator";

import { Position } from "./Position";

@Exclude()
export class Heatmap {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public _id: number;

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public originLocationId: string;

    @IsDefined()
    @Expose()
    public originLocationPosition: Position;

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public destinationLocationId: string;

    @IsDefined()
    @Expose()
    public destinationLocationPosition: Position;

    @IsDate()
    @IsDefined()
    @Expose()
    @Type(() => Date)
    public departureAt1: Date;

    @ArrayNotEmpty()
    @IsArray()
    @IsDefined()
    @Expose()
    @Type(() => Number)
    public vehicleIds: Array<VehicleType>;
}
